export default class AppActions {
    constructor(rootStore) {
        this._rootStore = rootStore;
    }

    setMediaWidth(width) {
        this._rootStore.app.setMediaWidth(width);
    }
}



// WEBPACK FOOTER //
// ./src/common/actions/AppActions.js